<div class="copo-wizzard-steps-container">
	<button type="button" *ngFor="let step of steps"
		class="copo-wizzard-step"
		[disabled]="step.status === WAIT"
		(click)="onStepClick(step.num)"
		[class.copo-wizzard-label-done]="step.status === DONE">
		<div class="copo-wizzard-step-mark-container">
			<div class="copo-wizzard-step-mark"
			mat-ripple
			[matRippleDisabled]="step.status === WAIT"
			[class.copo-wizzard-label-wip]="step.status === WIP"
			[class.copo-wizzard-label-wait]="step.status === WAIT"
			>
				<span>{{ step.num + 1 }}</span>
			</div>
		</div>
		<div class="copo-wizzard-step-label-container"
		[class.copo-wizzard-label-wip]="step.status === WIP"
		[class.copo-wizzard-label-wait]="step.status === WAIT"
		>
			<span translate>{{ step.labelTransId }}</span>
		</div>
	</button>
	<button *ngIf="isSummaryStep()" type="button" mat-icon-button (click)="print()" class="print-button">
		<mat-icon svgIcon="md:print" class="print-icon"></mat-icon>
	</button>
</div>